"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectList = void 0;
require("reflect-metadata");
var DecoratorSymbol_1 = require("./DecoratorSymbol");
/**
 * Decorate a field as a list of model relation
 *
 * @param constructor
 * @constructor
 */
var ObjectList = function (constructor) {
    return function (Target, property) {
        Object.defineProperty(Target, property, {
            enumerable: true,
            configurable: true,
            get: function () {
                return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
            },
            set: function (value) {
                Object.defineProperty(this, property, {
                    enumerable: true,
                    configurable: false,
                    get: function () {
                        return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
                    },
                    set: function (value) {
                        var InstanceConstructor = constructor !== null && constructor !== void 0 ? constructor : Target.constructor;
                        var instances = value === null || value === void 0 ? void 0 : value.map(function (element) {
                            var instance;
                            if (typeof InstanceConstructor.create === 'function') {
                                instance = InstanceConstructor.create();
                            }
                            else {
                                instance = new InstanceConstructor();
                            }
                            if (typeof element === 'object' && element !== null) {
                                Object.assign(instance, element);
                            }
                            return instance;
                        });
                        Reflect.defineMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, instances, this, property);
                    }
                });
                this[property] = value;
            }
        });
    };
};
exports.ObjectList = ObjectList;
//# sourceMappingURL=ObjectList.js.map